import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_2 = { class: "row justify-content-between animated fadeIn" }
const _hoisted_3 = { class: "col-xl-4 col-md-12" }
const _hoisted_4 = { class: "row justify-content-between" }
const _hoisted_5 = { class: "col-5 col-sm-6 col-md-5 col-lg-4" }
const _hoisted_6 = /*#__PURE__*/_createVNode("option", { value: "" }, "ALL", -1)
const _hoisted_7 = { class: "col-7 col-sm-6 col-md-7 col-lg-8" }
const _hoisted_8 = { class: "col-xl-4 col-md-6 col-sm-12 d-flex" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "mt-2 mr-2 w-25" }, "From:", -1)
const _hoisted_10 = { class: "col-xl-4 col-md-6 col-sm-12 d-flex justify-content-end" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "mt-2 mr-2 w-25" }, "To:", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-lg-12 " }
const _hoisted_15 = { class: "table-header text-right" }
const _hoisted_16 = { class: "dropdown mr-2" }
const _hoisted_17 = /*#__PURE__*/_createVNode("b", null, "D/W", -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "fas fa-file-download" }, null, -1)
const _hoisted_20 = {
  class: "dropdown-menu",
  "aria-labelledby": "dropdownDWButton"
}
const _hoisted_21 = { class: "dropdown" }
const _hoisted_22 = /*#__PURE__*/_createVNode("b", null, "Orders", -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_24 = /*#__PURE__*/_createVNode("i", { class: "fas fa-file-download" }, null, -1)
const _hoisted_25 = {
  class: "dropdown-menu",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" There are no records to show. ")
const _hoisted_27 = {
  key: 0,
  class: "badge badge-primary"
}
const _hoisted_28 = {
  key: 1,
  class: "badge badge-info"
}
const _hoisted_29 = {
  key: 2,
  class: "badge badge-success"
}
const _hoisted_30 = {
  key: 3,
  class: "badge badge-danger"
}
const _hoisted_31 = {
  key: 4,
  class: "badge badge-warning"
}
const _hoisted_32 = {
  key: 5,
  class: "badge badge-danger"
}
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { key: 2 }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("title", null, "Details"),
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_IconsCurrency = _resolveComponent("IconsCurrency")
  const _component_router_link = _resolveComponent("router-link")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _withDirectives(_createVNode("select", {
              class: "custom-select",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.currencyId = $event))
            }, [
              _hoisted_6,
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getCurrencies, (item) => {
                return (_openBlock(), _createBlock("option", {
                  value: item.id,
                  key: item.id
                }, _toDisplayString(item.id), 9, ["value"]))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.currencyId]
            ])
          ]),
          _createVNode("span", _hoisted_7, [
            _createVNode("button", {
              class: ["btn", { 'btn-primary': _ctx.period == '1D' }],
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.interval('1D')))
            }, " 1 D ", 2),
            _createVNode("button", {
              class: ["btn", { 'btn-primary': _ctx.period == '1W' }],
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.interval('1W')))
            }, " 1 W ", 2),
            _createVNode("button", {
              class: ["btn", { 'btn-primary': _ctx.period == '1M' }],
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.interval('1M')))
            }, " 1 M ", 2),
            _createVNode("button", {
              class: ["btn", { 'btn-primary': _ctx.period == '3M' }],
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.interval('3M')))
            }, " 3 M ", 2)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _withDirectives(_createVNode("input", {
          class: "form-control",
          type: "datetime-local",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.from = $event)),
          max: _ctx.max
        }, null, 8, ["max"]), [
          [_vModelText, _ctx.from]
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _hoisted_11,
        _withDirectives(_createVNode("input", {
          class: "form-control",
          type: "datetime-local",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.to = $event)),
          max: _ctx.max
        }, null, 8, ["max"]), [
          [_vModelText, _ctx.to]
        ])
      ])
    ]),
    _hoisted_12,
    _createVNode("div", _hoisted_13, [
      _createVNode("div", _hoisted_14, [
        _createVNode(_component_DataTable, {
          loading: _ctx.getStatus === 'fetching',
          class: "table-striped p-datatable-sm",
          autoLayout: true,
          value: _ctx.getStatements,
          paginator: true,
          rows: 10,
          paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
          rowsPerPageOptions: [10, 20, 50],
          currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}"
        }, {
          header: _withCtx(() => [
            _createVNode("div", _hoisted_15, [
              _createVNode("span", _hoisted_16, [
                _createVNode("button", {
                  disabled: _ctx.getStatus == 'fetching',
                  class: "btn btn-primary btn-sm dropdown-toggle",
                  type: "button",
                  id: "dropdownDWButton",
                  "data-toggle": "dropdown",
                  "aria-expanded": "false"
                }, [
                  _hoisted_17,
                  _hoisted_18,
                  _hoisted_19
                ], 8, ["disabled"]),
                _createVNode("div", _hoisted_20, [
                  _createVNode("button", {
                    class: "dropdown-item",
                    href: "#",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.downloadDW('xls')))
                  }, "xls"),
                  _createVNode("button", {
                    class: "dropdown-item",
                    href: "#",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.downloadDW('csv')))
                  }, "csv")
                ])
              ]),
              _createVNode("span", _hoisted_21, [
                _createVNode("button", {
                  disabled: _ctx.getStatus == 'fetching',
                  class: "btn btn-primary btn-sm dropdown-toggle",
                  type: "button",
                  id: "dropdownMenuButton",
                  "data-toggle": "dropdown",
                  "aria-expanded": "false"
                }, [
                  _hoisted_22,
                  _hoisted_23,
                  _hoisted_24
                ], 8, ["disabled"]),
                _createVNode("div", _hoisted_25, [
                  _createVNode("button", {
                    class: "dropdown-item",
                    href: "#",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.downloadOrders('xls')))
                  }, "xls"),
                  _createVNode("button", {
                    class: "dropdown-item",
                    href: "#",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.downloadOrders('csv')))
                  }, "csv")
                ])
              ])
            ])
          ]),
          empty: _withCtx(() => [
            _hoisted_26
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "createdAt",
              header: "Date"
            }, {
              body: _withCtx(({data}) => [
                _createTextVNode(_toDisplayString(_ctx.formatDate(data.createdAt)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Type",
              headerClass: "text-center",
              bodyClass: "text-center"
            }, {
              body: _withCtx(({data}) => [
                (data.type === 1)
                  ? (_openBlock(), _createBlock("span", _hoisted_27, " Order Base "))
                  : (data.type === 2)
                    ? (_openBlock(), _createBlock("span", _hoisted_28, " Order "))
                    : (data.type === 3)
                      ? (_openBlock(), _createBlock("span", _hoisted_29, " Deposit "))
                      : (data.type === 4)
                        ? (_openBlock(), _createBlock("span", _hoisted_30, " Deposit Canceled "))
                        : (data.type === 5)
                          ? (_openBlock(), _createBlock("span", _hoisted_31, " Withdrawal "))
                          : (data.type === 6)
                            ? (_openBlock(), _createBlock("span", _hoisted_32, " Withdrawal Canceled "))
                            : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Pair",
              headerClass: "text-center",
              bodyClass: "text-center"
            }, {
              body: _withCtx(({data}) => [
                (
                (_ctx.getStatusCurrenciesSatstreet == 'success' &&
                  data.type === 1) ||
                  data.type === 2
              )
                  ? (_openBlock(), _createBlock("span", _hoisted_33, [
                      (_ctx.splitPair(data.order.pairId).pairType == 'mix')
                        ? (_openBlock(), _createBlock("span", _hoisted_34, [
                            _createVNode(_component_IconsCurrency, {
                              pairType: _ctx.splitPair(data.order.pairId).pairType,
                              localCurrency: _ctx.splitPair(data.order.pairId).fiat.first,
                              cryptoCurrency: _ctx.splitPair(data.order.pairId).crypto.first,
                              width: '20',
                              height: '20'
                            }, null, 8, ["pairType", "localCurrency", "cryptoCurrency"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.splitPair(data.order.pairId).pairType == 'crypto')
                        ? (_openBlock(), _createBlock("span", _hoisted_35, [
                            _createVNode(_component_IconsCurrency, {
                              pairType: _ctx.splitPair(data.order.pairId).pairType,
                              localCurrency: _ctx.splitPair(data.order.pairId).crypto.second,
                              cryptoCurrency: _ctx.splitPair(data.order.pairId).crypto.first,
                              width: '20',
                              height: '20'
                            }, null, 8, ["pairType", "localCurrency", "cryptoCurrency"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.splitPair(data.order.pairId).pairType == 'fiat')
                        ? (_openBlock(), _createBlock("span", _hoisted_36, [
                            _createVNode(_component_IconsCurrency, {
                              pairType: _ctx.splitPair(data.order.pairId).pairType,
                              localCurrency: _ctx.splitPair(data.order.pairId).fiat.second,
                              cryptoCurrency: _ctx.splitPair(data.order.pairId).fiat.first,
                              width: '20',
                              height: '20'
                            }, null, 8, ["pairType", "localCurrency", "cryptoCurrency"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createBlock(_component_IconsCurrency, {
                      key: 1,
                      cryptoCurrency: _ctx.ifCrypto(data.currencyId),
                      localCurrency: _ctx.ifLocal(data.currencyId),
                      width: '20',
                      height: '20'
                    }, null, 8, ["cryptoCurrency", "localCurrency"]))
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Previous Balance",
              headerClass: "text-right",
              bodyClass: "text-right"
            }, {
              body: _withCtx(({data}) => [
                (_ctx.ifCrypto(data.currencyId))
                  ? (_openBlock(), _createBlock("span", _hoisted_37, _toDisplayString(_ctx.formatZeros(data.previousBalance, data.currency.exact)) + " " + _toDisplayString(data.currencyId), 1))
                  : (_openBlock(), _createBlock("span", _hoisted_38, " $ " + _toDisplayString(_ctx.formatPrice(data.previousBalance)) + "  " + _toDisplayString(data.currencyId), 1))
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Amount",
              headerClass: "text-right",
              bodyClass: "text-right"
            }, {
              body: _withCtx(({data}) => [
                _createVNode("span", {
                  class: { 'text-danger': data.amount < 0 }
                }, [
                  (_ctx.ifCrypto(data.currencyId))
                    ? (_openBlock(), _createBlock("span", _hoisted_39, _toDisplayString(_ctx.formatZeros(data.amount, data.currency.exact)) + "  " + _toDisplayString(data.currencyId), 1))
                    : (_openBlock(), _createBlock("span", _hoisted_40, " $ " + _toDisplayString(_ctx.formatPrice(data.amount)) + " " + _toDisplayString(data.currencyId), 1))
                ], 2)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Final Balance",
              headerClass: "text-right",
              bodyClass: "text-right"
            }, {
              body: _withCtx(({data}) => [
                (_ctx.ifCrypto(data.currencyId))
                  ? (_openBlock(), _createBlock("span", _hoisted_41, _toDisplayString(_ctx.formatZeros(data.finalBalance, data.currency.exact)) + " " + _toDisplayString(data.currencyId), 1))
                  : (_openBlock(), _createBlock("span", _hoisted_42, " $ " + _toDisplayString(_ctx.formatPrice(data.finalBalance)) + " " + _toDisplayString(data.currencyId), 1))
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Actions",
              headerClass: "text-center",
              bodyClass: "text-center"
            }, {
              body: _withCtx(({data}) => [
                (data.order)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: {
                name:
                  (_ctx.$isAdmin ? 'on-behalf-of.' : '') +
                  'account.statement.order.detail',
                params: { id: data.order.uuid, customerId: data.order.customerId }
              }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_43
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading", "value"])
      ])
    ])
  ], 64))
}